<script>
  import { useOutsideClick } from '@/helpers';
  import IconClose from '@/assets/icon-close.svg';

  export default {
    components: {
      IconClose,
    },

    props: {
      title: {
        type: String,
        required: false,
      },

      subtitle: {
        type: String,
        required: false,
      },
    },

    mounted () {
      useOutsideClick(this, 'modal', () => this.$emit('close'));
    },
  };
</script>

<template>
  <div
    class="modal"
    >
    <div
      ref="modal"
      class="modal__wrapper scale"
      >
      <div
        class="modal__header"
        :class="{ 'modal__header--empty': ! title }"
        >
        <div
          v-if="title"
          class="modal__header-info"
          >
          <h3
            v-text="title"
            class="modal__title"
            >
          </h3>
          <p
            v-if="subtitle"
            v-text="subtitle"
            class="modal__subtitle"
            >
          </p>
        </div>

        <button
          class="modal__close"
          @click="$emit('close')"
          >
          <IconClose />
        </button>
      </div>

      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss">
  .modal {
    top: 0;
    left: 0;
    z-index: 5;
    width: 100vw;
    height: 100vh;
    display: flex;
    padding: 70px 0;
    position: fixed;
    align-items: center;
    justify-content: center;
    background-color: rgba(#14162f, .83);

    &__wrapper {
      padding: 56px;
      min-width: 490px;
      border-radius: 4px;
      background-color: #26283f;
      box-shadow: 0 2px 5px 0 rgba(#000, .05);
    }

    &__header {
      width: 100%;
      display: flex;
      margin-bottom: 32px;
      align-items: flex-start;

      &--empty {
        margin-bottom: -24px;
      }
    }

    &__title {
      color: #FFF;
      font-size: 20px;
      letter-spacing: .4px;
    }

    &__subtitle {
      font-size: 14px;
      margin-top: 8px;
      line-height: 1.14;
      color: rgba(#b2b8c5, .7);
    }

    &__close {
      margin-left: auto;
    }

    &__action {
      color: #FFF;
      padding: 14px 24px;
      border-radius: 4px;
      letter-spacing: .32px;
      border: 1px solid #3e388b;
      background-color: #3e388b;

      &:hover {
        border-color: #322c76;
        background-color: #322c76;
      }

      &--cancel {
        background-color: transparent;
        border-color: #FFF !important;
      }

      &--cancel:hover {
        background-color: rgba(#FFF, .1) !important;
      }

      &--full {
        width: 100%;
      }
    }
  }
</style>
